import { render, staticRenderFns } from "./BackofficeContainer.vue?vue&type=template&id=2be771e7"
import script from "./BackofficeContainer.vue?vue&type=script&lang=js"
export * from "./BackofficeContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports